var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o);
} return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); });
} return e; }
import { Avatar, Grid, Typography } from '@mui/material';
import React, { useEffect, useState } from 'react';
import { CrossSvgIcon } from '../../../assets/customIcons';
// import { ReactComponent as GreenTickVerifyTick } from '../../../assets/images/CheckIcon'
import { Verified } from '@mui/icons-material';
import { DynamicFormBuilderContainer } from '../../../builderPackage/components/dynamicFormBuilder/formBuilder/dynamicFormBuilder.container';
import { FormItemTypes } from '../../../builderPackage/components/dynamicFormBuilder/formBuilder/dynamicFormBuilder.entity';
import { ValidationTypes } from '../../../builderPackage/components/regex/validations';
import { LOCAL_STORAGE_KEYS } from '../../../constants';
import { deleteState, updateAPI } from '../../../redux/crudSlice';
import { useAppDispatch, useAppSelector } from '../../../store/hooks';
import { getLocalStorageItem } from '../../../utils/storageHelper';
import { ContactPreferrenceList, getCustomerDetailAPICall, LanguageListApi, SendMobileOtpAPI, VerifyMobileOtpAPI } from './services/apiCall';
import { EditCustomerInfoKeys, updateCustomerInfoURL } from './services/entity';
var EditCustomerdetails = function (_ref) {
    var _customerInfo$data, _crud$EditCustomerInf, _crud$EditCustomerInf2, _crud$EditCustomerInf3, _customerInfo$data$Ad, _customerInfo$data2, _customerInfo$data$Ad2, _customerInfo$data3;
    var onClose = _ref.onClose;
    var timer = 30;
    var dispatch = useAppDispatch();
    var _a = useState(timer), counter = _a[0], setCounter = _a[1];
    var _b = useState(false), isCounterActive = _b[0], setIsCounterActive = _b[1];
    var selectedBranch = getLocalStorageItem(LOCAL_STORAGE_KEYS.SELECTED_BRANCH);
    var customerInfo = useAppSelector(function (state) { return state.crud; }).customerInfo;
    var _c = useState(customerInfo === null || customerInfo === void 0 || (_customerInfo$data = customerInfo.data) === null || _customerInfo$data === void 0 || (_customerInfo$data = _customerInfo$data.PersonContactPoint) === null || _customerInfo$data === void 0 || (_customerInfo$data = _customerInfo$data[0]) === null || _customerInfo$data === void 0 ? void 0 : _customerInfo$data.IsMobileVerified), isMobileVerified = _c[0], setIsMobileVerified = _c[1];
    var _d = useState(), otpTimer = _d[0], setOtpTimer = _d[1];
    var crud = useAppSelector(function (state) { return state.crud; });
    var handleMobileChange = function () {
        setIsMobileVerified(false);
    };
    var handleSendOtp = function () {
        SendMobileOtpAPI({
            request: {
                MobileNumber: "9933589128",
                ModelName: "Pulsar N 160",
                RegNo: "TN29CB0339"
            }
        });
    };
    useEffect(function () {
        dispatch(deleteState({
            key: EditCustomerInfoKeys.VerifyMobileOtp
        }));
        console.log('EditCustomerInfoKeys.VerifyMobileOtp-- -- ', typeof crud[EditCustomerInfoKeys.VerifyMobileOtp]);
    }, []);
    useEffect(function () {
        var timer;
        if (isCounterActive && counter > 0) {
            timer = setInterval(function () {
                setCounter(function (prevCounter) { return prevCounter - 1; });
            }, 1000);
        }
        return function () { return clearInterval(timer); };
    }, [isCounterActive, counter]);
    var sendOtp = function () {
        setCounter(timer);
        setIsCounterActive(true);
    };
    var formData = [{
            type: FormItemTypes.Box,
            name: '',
            columnSize: 12,
            paddingTop: '24px',
            elements: [{
                    type: FormItemTypes.Box,
                    name: '',
                    columnSize: 12,
                    display: 'flex',
                    justifyContent: 'space-between',
                    padding: 0,
                    elements: [{
                            type: FormItemTypes.Typography,
                            name: 'title',
                            value: null,
                            label: 'Edit customer info',
                            labelTypographyProps: {
                                fontWeight: 'bold',
                                color: 'black',
                                fontSize: '20px'
                            },
                            columnSize: 10
                        }, {
                            type: FormItemTypes.IconButton,
                            name: 'closeicon',
                            columnSize: 0.5,
                            children: /*#__PURE__*/ React.createElement(CrossSvgIcon, {
                                sx: {
                                    fontSize: 20
                                }
                            }),
                            onClick: function (e) {
                                onClose(e.currentTarget.id === 'Confirm');
                            }
                        }]
                }, {
                    type: FormItemTypes.Typography,
                    name: 'desc',
                    value: 'Please enter details of the customer',
                    columnSize: 10,
                    padding: 0,
                    sx: {
                        color: 'secondary.500'
                    },
                    labelTypographyProps: {
                        variant: 'h6'
                    }
                }]
        }, {
            type: FormItemTypes.Box,
            name: 'profile-pic',
            display: 'flex',
            columnSize: 12,
            elements: [{
                    type: FormItemTypes.Custom,
                    name: 'profiepic',
                    element: function () { /*#__PURE__*/ return React.createElement(Avatar, {
                        sx: {
                            height: '64px',
                            width: '64px'
                        }
                    }); },
                    columnSize: 2
                }]
        }, {
            type: FormItemTypes.TextInput,
            name: 'GivenName',
            label: 'First name',
            value: null,
            xs: 12,
            sm: 6,
            md: 6,
            lg: 6,
            disabled: true
        }, {
            type: FormItemTypes.TextInput,
            name: 'FamilyName',
            label: 'Last name',
            xs: 12,
            sm: 6,
            md: 6,
            lg: 6,
            disabled: true
        },
        // {
        //     type: FormItemTypes.NumberInput,
        //     name: 'MobileNumber',
        //     label: 'Mobile No.',
        //     value: null,
        //     columnSize: 6,
        //     required: true,
        //     validation: ValidationTypes.mobile,
        // },
        // {
        //     type: FormItemTypes.IconButton,
        //     name: 'searchButton',
        //     columnSize: 0,
        //     color: 'secondary',
        //     children: <Search color='secondary' />,
        // },
        crud[EditCustomerInfoKeys.VerifyMobileOtp] == undefined ? {
            type: FormItemTypes.ContainerItem,
            name: '',
            label: '',
            value: null,
            columnSize: 12,
            elements: [{
                    type: FormItemTypes.Typography,
                    name: 'MobileNumbe',
                    label: 'Mobile No',
                    value: null,
                    columnSize: true,
                    labelTypographyProps: {
                        m: 0
                    }
                }, {
                    type: FormItemTypes.Stack,
                    name: 'actions',
                    direction: 'row',
                    alignItems: 'center',
                    columnGap: 0.5,
                    borderRadius: 2,
                    m: 2,
                    p: 0.5,
                    border: '1px solid',
                    borderColor: 'secondary.300',
                    bgcolor: 'white',
                    width: '100%',
                    // maxWidth: 265,
                    elements: [{
                            type: FormItemTypes.NumberInput,
                            name: 'PrimaryMobileNo',
                            columnSize: true,
                            // variant: 'standard',
                            // required: true,
                            // value:'',
                            minLength: 10,
                            placeholder: 'Enter Mobile no',
                            // InputProps: { disableUnderline: true },
                            validation: ValidationTypes.mobile
                            // setFormState(formValues, currValue, field) {
                            //     // setMobileNo(formValues?.MobileNo)
                            //     return {
                            //         MobileNo: currValue
                            //     }
                            // },
                        }, {
                            type: FormItemTypes.IconButton,
                            name: 'verifyBtn',
                            columnSize: 0,
                            color: 'secondary',
                            // children: 'Verify',
                            children: ((_crud$EditCustomerInf = crud[EditCustomerInfoKeys.VerifyMobileOtp]) === null || _crud$EditCustomerInf === void 0 ? void 0 : _crud$EditCustomerInf.statusCode) == 200 ? /*#__PURE__*/ React.createElement(Verified, {
                                color: "secondary"
                            }) : /*#__PURE__*/ React.createElement(Typography, null, "Verify"),
                            setFormState: function (formValues, currValue) { return __awaiter(void 0, void 0, void 0, function () {
                                var res;
                                return __generator(this, function (_a) {
                                    switch (_a.label) {
                                        case 0:
                                            console.log('formValues -- ', formValues);
                                            return [4 /*yield*/, SendMobileOtpAPI({
                                                    request: {
                                                        MobileNumber: formValues === null || formValues === void 0 ? void 0 : formValues.MobileNo,
                                                        ModelName: "Pulsar N 160",
                                                        RegNo: "TN29CB0339"
                                                    }
                                                })];
                                        case 1:
                                            res = _a.sent();
                                            return [2 /*return*/, {
                                                    verifyMobile: _objectSpread({}, res)
                                                }];
                                    }
                                });
                            }); }
                        }]
                }]
        } : {
            type: FormItemTypes.ContainerItem,
            name: '',
            label: '',
            value: null,
            columnSize: 12,
            elements: [{
                    type: FormItemTypes.Typography,
                    name: 'MobileNumbe',
                    label: 'Mobile No',
                    value: null,
                    columnSize: true,
                    labelTypographyProps: {
                        m: 0
                    }
                }, {
                    type: FormItemTypes.Stack,
                    name: 'actions',
                    direction: 'row',
                    alignItems: 'center',
                    columnGap: 0.5,
                    borderRadius: 2,
                    m: 2,
                    p: 0.5,
                    border: '1px solid',
                    borderColor: 'secondary.300',
                    bgcolor: 'white',
                    width: '100%',
                    // maxWidth: 265,
                    elements: [{
                            type: FormItemTypes.NumberInput,
                            name: 'SecondaryMobileNo',
                            columnSize: true,
                            variant: 'standard',
                            required: true,
                            placeholder: 'Enter Mobile no',
                            InputProps: {
                                disableUnderline: true
                            },
                            validation: ValidationTypes.mobile
                            // setFormState(formValues, currValue, field) {
                            //     setMobileNo(formValues?.MobileNo)
                            //     return {
                            //     }
                            // },
                        }, {
                            type: FormItemTypes.IconButton,
                            name: 'verifyBtn',
                            columnSize: 0,
                            color: 'secondary',
                            // children: 'Verify',
                            children: ((_crud$EditCustomerInf2 = crud[EditCustomerInfoKeys.VerifyMobileOtp]) === null || _crud$EditCustomerInf2 === void 0 ? void 0 : _crud$EditCustomerInf2.statusCode) == 200 ? /*#__PURE__*/ React.createElement(Verified, {
                                color: "secondary"
                            }) : 'Resend',
                            setFormState: function (formValues, currValue) { return __awaiter(void 0, void 0, void 0, function () {
                                var res;
                                return __generator(this, function (_a) {
                                    switch (_a.label) {
                                        case 0:
                                            console.log('formValues -- ', formValues);
                                            return [4 /*yield*/, SendMobileOtpAPI({
                                                    request: {
                                                        MobileNumber: formValues === null || formValues === void 0 ? void 0 : formValues.MobileNo,
                                                        ModelName: "Pulsar N 160",
                                                        RegNo: "TN29CB0339"
                                                    }
                                                })];
                                        case 1:
                                            res = _a.sent();
                                            return [2 /*return*/, {
                                                    verifyMobile: _objectSpread({}, res)
                                                }];
                                    }
                                });
                            }); }
                        }]
                }]
        }, !((_crud$EditCustomerInf3 = crud[EditCustomerInfoKeys.VerifyMobileOtp]) !== null && _crud$EditCustomerInf3 !== void 0 && _crud$EditCustomerInf3.success) ? {
            type: FormItemTypes.ContainerItem,
            name: '',
            label: '',
            value: null,
            columnSize: 12,
            setFieldProps: function (formValues, currValue, state) {
                var _formValues$verifyMob, _formValues$verifyMob2;
                return {
                    type: this.type,
                    display: (formValues === null || formValues === void 0 || (_formValues$verifyMob = formValues.verifyMobile) === null || _formValues$verifyMob === void 0 ? void 0 : _formValues$verifyMob.statusCode) == 200 ? 'flex' : (formValues === null || formValues === void 0 || (_formValues$verifyMob2 = formValues.verifyMobile) === null || _formValues$verifyMob2 === void 0 ? void 0 : _formValues$verifyMob2.statusCode) != 200 ? 'none' : 'none'
                };
            },
            elements: [{
                    type: FormItemTypes.Typography,
                    name: 'OtpLabel',
                    label: 'OTP',
                    value: null,
                    columnSize: true,
                    labelTypographyProps: {
                        m: 0
                    }
                }, {
                    type: FormItemTypes.Stack,
                    name: 'actions',
                    direction: 'row',
                    alignItems: 'center',
                    columnGap: 0.5,
                    borderRadius: 2,
                    m: 2,
                    p: 0.5,
                    border: '1px solid',
                    borderColor: 'secondary.300',
                    bgcolor: 'white',
                    width: '100%',
                    // maxWidth: 265,
                    setFieldProps: function (formValues, currValue) {
                        var _formValues$verifyMob3;
                        return {
                            type: this.type,
                            display: (formValues === null || formValues === void 0 || (_formValues$verifyMob3 = formValues.verifyMobile) === null || _formValues$verifyMob3 === void 0 ? void 0 : _formValues$verifyMob3.statusCode) == 200 ? 'flex' : 'none'
                        };
                    },
                    elements: [{
                            type: FormItemTypes.NumberInput,
                            name: 'Otp',
                            columnSize: true,
                            variant: 'standard',
                            placeholder: 'Enter Otp no',
                            InputProps: {
                                disableUnderline: true
                            }
                        }, {
                            type: FormItemTypes.IconButton,
                            name: 'verifyBtn',
                            columnSize: 0,
                            color: 'secondary',
                            value: '',
                            children: 'Verify Otp',
                            setFormState: function (formValue, currValue) { return __awaiter(void 0, void 0, void 0, function () {
                                var res;
                                return __generator(this, function (_a) {
                                    switch (_a.label) {
                                        case 0: return [4 /*yield*/, VerifyMobileOtpAPI({
                                                request: {
                                                    MobileNumber: formValue === null || formValue === void 0 ? void 0 : formValue.MobileNo,
                                                    VerificationCode: formValue === null || formValue === void 0 ? void 0 : formValue.Otp
                                                }
                                            })];
                                        case 1:
                                            res = _a.sent();
                                            return [2 /*return*/, {
                                                    verifyOtp: _objectSpread({}, res)
                                                }];
                                    }
                                });
                            }); }
                        }]
                }]
        } : null,
        // {
        //     type: FormItemTypes.NumberInput,
        //     name: 'Otp',
        //     label: 'OTP',
        //     value: null,
        //     columnSize: 9,
        // },
        // {
        //     type: FormItemTypes.Button,
        //     name: 'VerifyOtp',
        //     label: '.',
        //     children: 'Verify Otp',
        //     variant: 'contained',
        //     setFieldProps: (formValues, currValue) => (
        //         console.log('Verify Otp--', formValues),
        //         {
        //             type: FormItemTypes.Button,
        //             // display: 'none'
        //         }),
        //     setFormState: (formValues, currValue, field) => (
        //         console.log('formState -- ', formValues),
        //         VerifyMobileOtpAPI({
        //             request: {
        //                 MobileNumber: formValues?.MobileNo,
        //                 VerificationCode: formValues?.Otp,
        //             }
        //         }),
        //         {
        //         }
        //     ),
        // },
        {
            type: FormItemTypes.TextInput,
            name: 'Email',
            label: ' Email',
            columnSize: 12
        }, {
            type: FormItemTypes.TextInput,
            name: 'Address1',
            label: ' Address',
            value: (_customerInfo$data$Ad = customerInfo === null || customerInfo === void 0 || (_customerInfo$data2 = customerInfo.data) === null || _customerInfo$data2 === void 0 || (_customerInfo$data2 = _customerInfo$data2.Address[0]) === null || _customerInfo$data2 === void 0 ? void 0 : _customerInfo$data2.Address1) !== null && _customerInfo$data$Ad !== void 0 ? _customerInfo$data$Ad : null,
            columnSize: 12,
            disabled: true
        }, {
            type: FormItemTypes.TextInput,
            name: 'Address2',
            label: '',
            value: (_customerInfo$data$Ad2 = customerInfo === null || customerInfo === void 0 || (_customerInfo$data3 = customerInfo.data) === null || _customerInfo$data3 === void 0 || (_customerInfo$data3 = _customerInfo$data3.Address[0]) === null || _customerInfo$data3 === void 0 ? void 0 : _customerInfo$data3.Address2) !== null && _customerInfo$data$Ad2 !== void 0 ? _customerInfo$data$Ad2 : null,
            columnSize: 12,
            multiline: true,
            minRows: 2,
            disabled: true
        }, {
            type: FormItemTypes.SearchSelect,
            name: 'LanguageId',
            label: 'Preferred language',
            value: null,
            apiKey: 'languageList',
            apiRequest: {
                OrganizationId: selectedBranch === null || selectedBranch === void 0 ? void 0 : selectedBranch.OrganizationId
            },
            getListData: LanguageListApi,
            xs: 6,
            sm: 6,
            md: 6,
            lg: 6,
            displayExpr: 'Name',
            valueExpr: 'id'
        }, {
            type: FormItemTypes.SearchSelect,
            name: 'PersonContactPreference',
            label: 'Communication preference',
            required: true,
            value: null,
            displayExpr: 'Name',
            valueExpr: 'id',
            getListData: ContactPreferrenceList,
            xs: 12,
            sm: 6,
            md: 6,
            lg: 6,
            multiple: true
        }, {
            type: FormItemTypes.ContainerItem,
            name: '',
            sx: {
                padding: '24px 0px'
            },
            columnSize: 12,
            justifyContent: 'end',
            elements: [{
                    type: FormItemTypes.Button,
                    variant: 'contained',
                    name: 'Update',
                    label: '',
                    children: 'Update',
                    fullWidth: true,
                    onClick: function () { return 'submit'; },
                    xs: 12,
                    sm: 4,
                    md: 4,
                    lg: 2
                }, {
                    type: FormItemTypes.Button,
                    variant: 'outlined',
                    name: 'Cancel',
                    label: '',
                    children: 'Cancel',
                    xs: 12,
                    sm: 4,
                    md: 4,
                    lg: 2,
                    fullWidth: true,
                    onClick: function (e) {
                        onClose(e.currentTarget.id === 'Confirm');
                    }
                }]
        }];
    var id = '30da31c1-87dd-4db2-88e8-471aa392cb3d';
    return /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement(Grid, {
        padding: '0px 24px'
    }, /*#__PURE__*/ React.createElement(DynamicFormBuilderContainer, {
        mode: "edit",
        formData: formData,
        getFormAPI: getCustomerDetailAPICall,
        getKey: 'customerInfo',
        getRequest: {
            id: id
        },
        updateFormAPI: function (_ref2) { return __awaiter(void 0, void 0, void 0, function () {
            var request, req, res;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        request = _ref2.request;
                        req = {
                            PersonContactPoints: [{
                                    ContactType: "Primary",
                                    Email: "dummy9933589128@gmail.com",
                                    IsMobileVerified: true,
                                    MobileNo: request === null || request === void 0 ? void 0 : request.PrimaryMobileNo
                                }, {
                                    ContactType: "Secondary",
                                    IsAlternateNumberVerified: null,
                                    MobileNo: "0000000000"
                                }]
                        };
                        return [4 /*yield*/, dispatch(updateAPI({
                                key: 'updateCustomerInfo',
                                url: updateCustomerInfoURL(id),
                                request: req
                            }))];
                    case 1:
                        res = _a.sent();
                        console.log('response', res);
                        return [2 /*return*/, {
                                success: true
                            }];
                }
            });
        }); },
        updateKey: "updateCustomerInfo"
    })));
};
export default EditCustomerdetails;
